 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTSCRIPTURE from '@/components/Text/Scripture'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTOWPACSLEWIS from '@/components/Text/OWPACSLewis'
 import TEXTCHAP1 from '@/components/Text/chap1'
 import TEXTOWPAWEIL from '@/components/Text/OWPAWeil'
 import TEXTCHAP2 from '@/components/Text/chap2'
 import TEXTOWPADONOVAN from '@/components/Text/OWPADonovan'
 import TEXTCHAP3 from '@/components/Text/chap3'
 import TEXTOWPATEACHER from '@/components/Text/OWPATeacher'
 import TEXTCHAP4 from '@/components/Text/chap4'
 import TEXTOWPADOG from '@/components/Text/OWPADog'
 import TEXTCHAP5 from '@/components/Text/chap5'
 import TEXTOWPAKIERKEGAARD from '@/components/Text/OWPAKierkegaard'
 import TEXTCHAP6 from '@/components/Text/chap6'
 import TEXTOWPAMTERESA from '@/components/Text/OWPAMTeresa'
 import TEXTHOLYSTILLNESS from '@/components/Text/HolyStillness'
 import TEXTCHAP7 from '@/components/Text/chap7'
 import TEXTOWPASITTSER from '@/components/Text/OWPASittser'
 import TEXTCHAP8 from '@/components/Text/chap8'
 import TEXTOWPANOUWEN from '@/components/Text/OWPANouwen'
 import TEXTCHAP9 from '@/components/Text/chap9'
 import TEXTOWPATAN from '@/components/Text/OWPATan'
 import TEXTEPILOGUE from '@/components/Text/Epilogue'
 import TEXTAPPENDIX from '@/components/Text/Appendix'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTINATTENTIONTOGRATITUDE from '@/components/Text/InAttentiontoGratitude'
 import TEXTPERMISSIONS from '@/components/Text/Permissions'
 import TEXTENDORSEMENTS from '@/components/Text/endorsements'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTFORMATIO from '@/components/Text/Formatio'
 import TEXTMORETITLESFROMIVP from '@/components/Text/MoreTitlesfromIVP'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/OWPACSLewis",
 			"name" : "Text/OWPACSLewis",
 			"component" : TEXTOWPACSLEWIS
 		},
 		{
 			"path" : "/Text/chap1",
 			"name" : "Text/chap1",
 			"component" : TEXTCHAP1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js